import { PropsWithChildren } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { WarningIcon } from 'src/modules/common/icons/WarningIcon.tsx';
import { RenderHtml } from 'src/common/RenderHtml/RenderHtml.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { Tooltip } from 'src/modules/common/components/Tooltip/Tooltip.tsx';
import clsx from 'clsx';

/* eslint-disable react/no-danger */
export const ValveFlowWarning = ({ value }: PropsWithChildren<{ value : string }>) => {
    const valueParsed = parseFloat(value);
    if (valueParsed <= 2) {
        return (
            <RenderHtml
                className="vss-device__value"
                data={value}
            />
        );
    }
    return (
        <div className="vss-device__value">
            <span
                dangerouslySetInnerHTML={{
                    __html: value,
                }}

            />
            <div className={clsx({
                'vss-device__icon--warning': true,
                danger: valueParsed > 3,
            })}
            >
                <Tooltip
                    direction="top"
                    title=""
                    value={<I18n messageId={MESSAGES.ValveFlowVelocityWarning}/>}
                >
                    <WarningIcon/>
                </Tooltip>
            </div>
        </div>
    );
};
